"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
// import { windowAddEventListener, scaleAnimation } from './../../utils';
function BannerAnimation() {
  // useEffect(() => {
  //   windowAddEventListener(() => {
  //     scaleAnimation('tci-home-page-symbol-audiovb-animation-fake');
  //   }, 1);
  // }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "home-symbol-audiovb-level-banner-logo"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      background: 'url(https://staticintl.cloudcachetci.com/cms/backend-cms/rYUh919_111.png)'
    },
    className: "home-symbol-audiovb-level-banner-logo__loop is-enter "
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "home-symbol-audiovb-img-seven",
    src: "https://test-staticintl.cloudcachetci.com/cms/backend-cms/M43b335_02.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "home-symbol-audiovb-img-bg",
    src: "https://test-staticintl.cloudcachetci.com/cms/backend-cms/TLH8860_03.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "home-background-audiovb-img-bg",
    src: "https://test-staticintl.cloudcachetci.com/cms/backend-cms/Raxm431_bg2.png"
  })));
}
var _default = exports["default"] = BannerAnimation;